import { CRITICAL_FONTS_BY_LOB, type FontLob } from './criticalVdsFonts';

export type FontPreloadLinksProps = {
    lob?: FontLob;
};

/**
 * Emits early `<link rel="preload" as="font">` hints for critical VDS webfonts.
 * Pair with `@vds/core/dist/css/fonts.css` (via AppShell) which registers @font-face rules.
 * Render via {@link DocumentHeadAssets} in `_document`, not `next/head`.
 */
export function FontPreloadLinks({ lob = 'pplus' }: FontPreloadLinksProps) {
    const fonts = CRITICAL_FONTS_BY_LOB[lob] ?? CRITICAL_FONTS_BY_LOB.pplus;

    return (
        <>
            {fonts.map((href) => (
                <link
                    key={href}
                    rel="preload"
                    href={href}
                    as="font"
                    type="font/woff2"
                    crossOrigin="anonymous"
                />
            ))}
        </>
    );
}
